import { PropsWithChildren } from 'react';

import { ThemeProvider, theme } from 'configs/theme-configurator';

import { PageLoader, Error, NoData } from 'components';

type PageLayoutProps = {
  isLoading?: boolean;
  isError?: boolean;
  noData?: boolean;
};

// TODO: Carry out ThemeProvider to the top level when migration is finished
const PageLayout = ({
  children,
  isError,
  isLoading,
  noData,
}: PropsWithChildren<PageLayoutProps>) => {
  if (isLoading) return <PageLoader />;
  if (isError) return <Error />;
  if (noData) return <NoData />;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default PageLayout;
